import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, computed, signal } from '@angular/core';

import type { EntityFieldRow } from '../../mapping-types';

type DragPayload = {
  kind: 'entityField';
  fieldName: string;
};

@Component({
  selector: 'app-entity-field-palette',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './entity-field-palette.component.html',
  styleUrl: './entity-field-palette.component.scss',
})
export class EntityFieldPaletteComponent {
  private readonly fieldsSig = signal<EntityFieldRow[]>([]);

  @Input({ required: true })
  set fields(value: EntityFieldRow[]) {
    this.fieldsSig.set(Array.isArray(value) ? value : []);
  }
  get fields(): EntityFieldRow[] {
    return this.fieldsSig();
  }

  @Output() pickField = new EventEmitter<string>();

  protected readonly query = signal('');
  protected readonly filtered = computed(() => {
    const q = this.query().trim().toLowerCase();
    const fields = this.fieldsSig();
    if (!q) return fields;
    return fields.filter((f) => {
      const a = f.fieldName.toLowerCase();
      const b = (f.displayName ?? '').toLowerCase();
      return a.includes(q) || b.includes(q);
    });
  });

  setQuery(value: string): void {
    this.query.set(value);
  }

  handlePick(fieldName: string): void {
    this.pickField.emit(fieldName);
  }

  handleDragStart(e: DragEvent, fieldName: string): void {
    if (!e.dataTransfer) return;
    const payload: DragPayload = { kind: 'entityField', fieldName };
    e.dataTransfer.setData('application/x-indexcore', JSON.stringify(payload));
    e.dataTransfer.effectAllowed = 'copy';
  }
}

